import React, { useState, useEffect } from 'react';
import ScreenVisibilityToggles from './ScreenVisibilityToggles';
import PlatformSettingsPanel from './PlatformSettingsPanel';

const ALL_SCREEN_KEYS = [
  'dashboard', 'customer_management', 'bid_management', 'project_management',
  'resource_management', 'prospect_management', 'analytics', 'project_phases',
  'pm_dashboard', 'application_bug_tracker', 'team_administration', 'audit_log'
];

const SCREEN_META = {
  dashboard: { label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6', group: 'Operations' },
  customer_management: { label: 'Customers', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z', group: 'Operations' },
  bid_management: { label: 'Bids', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z', group: 'Operations' },
  project_management: { label: 'Projects', icon: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z', group: 'Operations' },
  resource_management: { label: 'Resources', icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4', group: 'Operations' },
  prospect_management: { label: 'Prospects', icon: 'M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5', group: 'Operations' },
  project_phases: { label: 'Phases', icon: 'M13 10V3L4 14h7v7l9-11h-7z', group: 'Operations' },
  pm_dashboard: { label: 'PM Dashboard', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z', group: 'Operations' },
  analytics: { label: 'Analytics', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z', group: 'Analytics' },
  team_administration: { label: 'Site Admin', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z', group: 'Admin' },
  audit_log: { label: 'Audit Log', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01', group: 'Admin' },
  application_bug_tracker: { label: 'Bug Tracker', icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z', group: 'Admin' },
};

const buildFullVisibility = (partial) => {
  const full = {};
  ALL_SCREEN_KEYS?.forEach((key) => {
    full[key] = partial?.[key] !== false;
  });
  return full;
};

// Mini device frame for test mode preview
const DevicePreview = ({ platform, visibility }) => {
  const isIOS = platform === 'ios';
  const visibleItems = ALL_SCREEN_KEYS?.filter(k => visibility?.[k] !== false);
  const hiddenItems = ALL_SCREEN_KEYS?.filter(k => visibility?.[k] === false);

  // Group visible items
  const groups = {};
  visibleItems?.forEach(key => {
    const meta = SCREEN_META?.[key];
    if (!meta) return;
    if (!groups?.[meta.group]) groups[meta.group] = [];
    groups?.[meta.group]?.push({ key, ...meta });
  });

  return (
    <div className="flex flex-col lg:flex-row gap-6">
      {/* Device frame */}
      <div className="flex-shrink-0 flex justify-center">
        <div className={`relative bg-gray-900 rounded-[2rem] p-2 shadow-2xl ${isIOS ? 'w-[200px]' : 'w-[196px]'}`}
          style={{ border: '3px solid #374151' }}>
          {/* Notch / camera */}
          {isIOS ? (
            <div className="absolute top-2 left-1/2 -translate-x-1/2 w-16 h-4 bg-gray-900 rounded-full z-10" />
          ) : (
            <div className="absolute top-3 left-1/2 -translate-x-1/2 w-3 h-3 bg-gray-700 rounded-full z-10" />
          )}
          {/* Screen */}
          <div className="bg-white rounded-[1.5rem] overflow-hidden" style={{ minHeight: 360 }}>
            {/* Status bar */}
            <div className="bg-gray-100 px-3 pt-5 pb-1 flex justify-between items-center">
              <span className="text-[8px] font-bold text-gray-600">9:41</span>
              <div className="flex gap-1 items-center">
                <div className="w-3 h-1.5 border border-gray-500 rounded-sm"><div className="w-2 h-full bg-gray-500 rounded-sm" /></div>
              </div>
            </div>
            {/* App header */}
            <div className="bg-blue-700 px-3 py-2 flex items-center gap-2">
              <div className="w-5 h-5 bg-white/20 rounded flex items-center justify-center">
                <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </div>
              <span className="text-white text-[9px] font-semibold">ConstructionPro</span>
            </div>
            {/* Menu items */}
            <div className="px-2 py-2 space-y-0.5 overflow-y-auto" style={{ maxHeight: 220 }}>
              {Object.entries(groups)?.map(([group, items]) => (
                <div key={group}>
                  <div className="text-[7px] font-bold text-gray-400 uppercase tracking-wider px-1 py-1">{group}</div>
                  {items?.map(item => (
                    <div key={item?.key} className="flex items-center gap-1.5 px-2 py-1 rounded bg-gray-50 mb-0.5">
                      <svg className="w-2.5 h-2.5 text-blue-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item?.icon} />
                      </svg>
                      <span className="text-[8px] text-gray-700 truncate">{item?.label}</span>
                    </div>
                  ))}
                </div>
              ))}
              {visibleItems?.length === 0 && (
                <div className="text-center py-6">
                  <span className="text-[8px] text-gray-400">No screens visible</span>
                </div>
              )}
            </div>
            {/* Bottom nav bar */}
            <div className="border-t border-gray-200 bg-white px-1 py-1 flex justify-around">
              {['dashboard', 'bid_management', 'customer_management']?.map(key => {
                const isVisible = visibility?.[key] !== false;
                const meta = SCREEN_META?.[key];
                return (
                  <div key={key} className={`flex flex-col items-center gap-0.5 px-1 ${isVisible ? 'opacity-100' : 'opacity-20'}`}>
                    <svg className={`w-3 h-3 ${isVisible ? 'text-blue-600' : 'text-gray-300'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={meta?.icon} />
                    </svg>
                    <span className={`text-[6px] ${isVisible ? 'text-blue-600' : 'text-gray-300'}`}>{meta?.label}</span>
                  </div>
                );
              })}
            </div>
          </div>
          {/* Home indicator */}
          {isIOS && (
            <div className="flex justify-center mt-1.5">
              <div className="w-12 h-1 bg-gray-600 rounded-full" />
            </div>
          )}
        </div>
      </div>
      {/* Summary panel */}
      <div className="flex-1 space-y-4">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" />
              {visibleItems?.length} Visible
            </span>
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-red-100 text-red-600 text-xs font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-red-400 inline-block" />
              {hiddenItems?.length} Hidden
            </span>
          </div>
          <div className="space-y-1">
            {visibleItems?.map(key => (
              <div key={key} className="flex items-center gap-2 text-xs text-foreground">
                <svg className="w-3 h-3 text-green-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                </svg>
                <span>{SCREEN_META?.[key]?.label || key}</span>
              </div>
            ))}
            {hiddenItems?.map(key => (
              <div key={key} className="flex items-center gap-2 text-xs text-muted-foreground line-through">
                <svg className="w-3 h-3 text-red-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span>{SCREEN_META?.[key]?.label || key}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
          <p className="text-xs text-amber-700 font-medium mb-0.5">Preview only</p>
          <p className="text-xs text-amber-600">This simulates how the mobile navigation will appear after saving. Changes are not live until you click "Save Visibility".</p>
        </div>
      </div>
    </div>
  );
};

const PlatformConfigTab = ({
  platform,
  screenVisibility,
  platformSettings,
  onSaveVisibility,
  onSavePlatformSettings,
  saving
}) => {
  const [localVisibility, setLocalVisibility] = useState(() => buildFullVisibility(screenVisibility));
  const [localPlatformSettings, setLocalPlatformSettings] = useState(platformSettings);
  const [testModeOpen, setTestModeOpen] = useState(false);

  useEffect(() => {
    setLocalVisibility(buildFullVisibility(screenVisibility));
  }, [screenVisibility]);

  useEffect(() => {
    setLocalPlatformSettings(platformSettings);
  }, [platformSettings]);

  const handleVisibilityToggle = (key) => {
    setLocalVisibility((prev) => ({ ...prev, [key]: !(prev?.[key] !== false) }));
  };

  const handlePlatformSettingChange = (key, value) => {
    setLocalPlatformSettings((prev) => ({ ...prev, [key]: value }));
  };

  const handleSaveAll = () => {
    onSaveVisibility(localVisibility);
  };

  const handleSavePlatformSettings = () => {
    onSavePlatformSettings(localPlatformSettings);
  };

  const platformLabel = platform === 'ios' ? 'iOS' : 'Android';

  return (
    <div className="space-y-6">
      {/* Screen Visibility */}
      <div className="bg-card border border-border rounded-xl p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-base font-semibold text-foreground">
              {platformLabel} Screen Visibility
            </h2>
            <p className="text-xs text-muted-foreground mt-0.5">
              Toggle which screens are accessible in the {platformLabel} PWA
            </p>
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => {
                const allOn = {};
                Object.keys(localVisibility)?.forEach((k) => { allOn[k] = true; });
                setLocalVisibility(allOn);
              }}
              className="text-xs text-primary hover:underline"
            >
              Enable all
            </button>
            <span className="text-muted-foreground">·</span>
            <button
              type="button"
              onClick={() => {
                const allOff = {};
                Object.keys(localVisibility)?.forEach((k) => { allOff[k] = false; });
                setLocalVisibility(allOff);
              }}
              className="text-xs text-muted-foreground hover:underline"
            >
              Disable all
            </button>
          </div>
        </div>
        <ScreenVisibilityToggles
          visibility={localVisibility}
          onToggle={handleVisibilityToggle}
        />
        <div className="flex items-center justify-between mt-4">
          <button
            type="button"
            onClick={() => setTestModeOpen(prev => !prev)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium border transition-all ${
              testModeOpen
                ? 'bg-primary/10 border-primary text-primary' :'bg-muted border-border text-muted-foreground hover:text-foreground hover:border-primary/40'
            }`}
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            {testModeOpen ? 'Hide Preview' : 'Test Mode Preview'}
          </button>
          <button
            onClick={handleSaveAll}
            disabled={saving}
            className="px-5 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:opacity-90 transition-opacity disabled:opacity-50 flex items-center gap-2"
          >
            {saving && <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />}
            Save Visibility
          </button>
        </div>
      </div>

      {/* Test Mode Panel */}
      {testModeOpen && (
        <div className="bg-card border border-primary/30 rounded-xl p-5">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary/10 text-primary text-xs font-semibold">
              <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
              Test Mode
            </span>
            <h3 className="text-sm font-semibold text-foreground">
              {platformLabel} Navigation Preview
            </h3>
          </div>
          <p className="text-xs text-muted-foreground mb-5">
            This preview reflects your <strong>current unsaved toggle state</strong>. Adjust toggles above and watch the preview update in real time before deploying to {platformLabel} devices.
          </p>
          <DevicePreview platform={platform} visibility={localVisibility} />
        </div>
      )}

      {/* Platform-Specific Settings */}
      <div className="bg-card border border-border rounded-xl p-5">
        <h2 className="text-base font-semibold text-foreground mb-4">
          {platformLabel} Platform Settings
        </h2>
        <PlatformSettingsPanel
          platform={platform}
          settings={localPlatformSettings}
          onChange={handlePlatformSettingChange}
        />
        <div className="flex justify-end mt-4">
          <button
            onClick={handleSavePlatformSettings}
            disabled={saving}
            className="px-5 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:opacity-90 transition-opacity disabled:opacity-50 flex items-center gap-2"
          >
            {saving && <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />}
            Save {platformLabel} Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlatformConfigTab;
